import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Body from '../modules/Body';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { url } from '../../../config';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Style
import { body, buttonStyle, center, fontWeightBold, marginBottom } from '../../../helpers/getEmailStyles';

class BookingPreApproval extends React.Component {

    static propTypes = {
        content: PropTypes.shape({
            guestName: PropTypes.string.isRequired,
            threadId: PropTypes.number.isRequired,
            listTitle: PropTypes.number.isRequired,
        })
    };

    render() {
        const { content: { guestName, threadId, listTitle, logo, siteName, checkIn, checkOut, personCapacity } } = this.props;
        let contactURL, checkInDate, checkOutDate
        contactURL = url + '/message/' + threadId + '/guest';
        checkInDate = checkIn != null ? moment(checkIn).format('ddd, Do MMM, YYYY') : '';
        checkOutDate = checkOut != null ? moment(checkOut).format('ddd, Do MMM, YYYY') : '';


        return (
            <Layout>
                <Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
                <div style={body}>
                    <div style={fontWeightBold}>
                        Hi {guestName},
                    </div>
                    <EmptySpace height={20} />
                    <div>
                        Great news! The host of {listTitle} has pre-approved your booking request. You can now confirm your stay for the selected dates.
                    </div>
                    <EmptySpace height={20} />
                    <div style={marginBottom}><span style={fontWeightBold}>Booking Details:-</span></div>
                    <div style={marginBottom}><span style={fontWeightBold}>Listing:</span> {listTitle}</div>
                    <div style={marginBottom}><span style={fontWeightBold}>Check-in:</span> {checkInDate}</div>
                    <div style={marginBottom}><span style={fontWeightBold}>Check-out:</span> {checkOutDate}</div>
                    <div style={marginBottom}><span style={fontWeightBold}>Guests:</span> {personCapacity}</div>
                    <div>
                        Click the button below to complete your booking:
                    </div>
                    <EmptySpace height={20} />
                    <div style={center}>
                        <a style={buttonStyle} href={contactURL}>Book Now</a>
                    </div>
                    <EmptySpace height={20} />
                    <EmailSignature siteName={siteName} />
                </div>
                <EmptySpace height={40} />
                <Footer siteName={siteName} />
                <EmptySpace height={20} />
            </Layout>
        );
    }

}

export default BookingPreApproval;